import {triggersApi} from 'sources/api';
import {List} from 'immutable';

export default {
  fetchDefaultTriggerTags() {
    return triggersApi.getJson('/tags/default').then(response => {
      return new List(response);
    });
  },
};
